export const formatCurrency = (
  value: number,
  currencyCode: string,
  locale: string
) => {
  return new Intl.NumberFormat(locale, {
    currency: currencyCode,
    style: "currency",
  }).format(value)
}
